<template>
  <div>This is about page!!!</div>
</template>

<script>
export default {

}
</script>

<style>

</style>